import * as t from "io-ts";

export const BusinessSector = t.union([
  t.literal("Home improvement"),
  t.literal("Renewables"),
  t.literal("Retail"),
  t.literal("IT and technology Services"),
  t.literal("Automotive services"),
  t.literal("Training and education"),
  t.literal("Events (including weddings)"),
  t.literal("Healthcare"),
  t.literal("Other"),
]);

export type BusinessSector =
  | "Home improvement"
  | "Renewables"
  | "Retail"
  | "IT and technology Services"
  | "Automotive services"
  | "Training and education"
  | "Events (including weddings)"
  | "Healthcare"
  | "Other";
